<template>
  <div class="hidden-home-button" @click="homePress" v-if="isIadea || isCondeco">
    <v-chip v-if="home.clickCounter >= 5" class="status">
      Tap {{ remainingClicks }} more time{{ remainingClicks > 1 ? 's' : '' }} to go to setup
    </v-chip>
  </div>
</template>

<script>
import iadeaApi from '@/api/panel-api-iadea';
import {mapGetters} from 'vuex';

export default {
  name: 'GoToSetup',
  data() {
    return {
      home: {
        clicksNeeded: 10,
        clickTimeoutMs: 5000,
        clickCounter: 0,
        timer: 0
      }
    };
  },
  computed: {
    ...mapGetters('config', ['panelType']),
    isCondeco() {
      return this.panelType === 'condeco';
    },
    isIadea() {
      return this.panelType === 'iadea';
    },
    remainingClicks() {
      return 10 - this.home.clickCounter;
    }
  },
  methods: {
    homePress() {
      if (this.home.clickCounter === 0) {
        this.home.timer = setTimeout(() => {
          this.home.clickCounter = 0;
        }, this.home.clickTimeoutMs);
      }
      this.home.clickCounter++;
      if (this.home.clickCounter >= this.home.clicksNeeded) {
        this.home.clickCounter = 0;
        clearTimeout(this.home.timer);
        if (this.isIadea) {
          this.$logger.info('goHomeRetry');
          iadeaApi.goHomeRetry();
        } else if (this.isCondeco) {
          location.href = 'http://localhost:8080';
        }
      }
    }
  }
};
</script>

<style scoped>
.hidden-home-button {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 100px;
  width: 100px;
}
.hidden-home-button .status {
  position: absolute;
  left: -300px;
  top: 40%;
  max-width: unset;
}
</style>
